import { playSound, Sound } from '~/assets/sounds';
import { rage, useObservable } from '~/rage';
import {
	StyledContainer,
	StyledLabelContainer,
	StyledParkingSlotsButton,
} from './ParkingSlotsInfo.styled';

const ParkingSlotsInfo = () => {
	const availableSlots = useObservable(rage.player.getTotalParkingSlots());
	const usedSlots = useObservable(rage.player.getUsedParkingSlots());

	const handleButtonClick = () => {
		rage.player.showBuyParkingSlotsModal();
	};

	return (
		<StyledContainer>
			<StyledLabelContainer>
				{usedSlots}
				<span>&#160;/ {availableSlots} м.</span>
			</StyledLabelContainer>
			<StyledParkingSlotsButton
				onClick={() => {
					handleButtonClick();
					playSound(Sound.ClickButton);
				}}
				onMouseEnter={() => playSound(Sound.LinkCursor)}
			/>
		</StyledContainer>
	);
};

export { ParkingSlotsInfo };
